"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _propTypes = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["colorScheme", "type", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var BadgeWithoutDocs = function BadgeWithoutDocs(_ref) {
  var _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? _constants.badgeDefaultProps.colorScheme : _ref$colorScheme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? _constants.badgeDefaultProps.type : _ref$type,
      value = _ref.value,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_helperComponents.BadgeWrapper, (0, _extends2.default)({
    colorScheme: colorScheme,
    type: type
  }, (0, _utils.pickDataProps)(forwardedProps)), (0, _core.jsx)(_helperComponents.BadgeText, {
    fontSize: "T50",
    fontWeight: "medium"
  }, value));
};

var BadgeWithDocs = (0, _stencilReactDesc.describe)(BadgeWithoutDocs).description('A Badge is a pill shaped non-interactive component usually holding a numeric value.');
BadgeWithDocs.defaultProps = _objectSpread({}, _constants.badgeDefaultProps);
BadgeWithDocs.propTypes = _objectSpread({}, _propTypes.badgePropTypes);
var Badge = (0, _utils.withTestAttributes)({
  component: 'StencilBadge'
})(BadgeWithDocs);
Badge.displayName = 'Badge';
var _default = Badge;
exports.default = _default;